import { createFileRoute } from '@tanstack/react-router';
import { AdminCoachConversationsView } from '@/components/admin/AdminCoachConversationsView';

interface CoachSearch {
  readonly conversation?: string;
}

export const Route = createFileRoute('/_authed/admin/coach/')({
  // A rejected key is returned as explicit `undefined`: the router merges this
  // result over the raw URL search, so an omitted key would let the raw value
  // through to `useSearch()`.
  validateSearch: (raw: Record<string, unknown>): CoachSearch => ({
    conversation:
      typeof raw.conversation === 'string' && raw.conversation.length > 0
        ? raw.conversation
        : undefined,
  }),
  component: CoachConversationsPage,
});

function CoachConversationsPage() {
  const { conversation } = Route.useSearch();
  return <AdminCoachConversationsView openConversationId={conversation ?? null} />;
}
